<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('settings/settings:scheduler.scheduler') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            :addBtnText="$t('buttons:add-specific', {specific: $t('settings/settings:scheduler.scheduler') })"
            :trueFalseDecorateFields="trueFalseDecorateFields"
            icon2="delete"
            @clickedButton2="deleteScheduler"
            icon="edit"
            @updateTableData="updateTable"
            @clickedButton1="editScheduler"
            @clickedAddButton="editScheduler"
            :addBtn="true"
            sortBy="name"
        />

      </v-col>
    </v-row>

    <SchedulerForm
        @updateTable="updateTableAfterManipulation"
        ref="schedulerForm" />

  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import SchedulerForm from '@/modules/settings/views/settings/schedule/SchedulerForm.vue';
import SchedulerService from '@/modules/settings/services/scheduler-service';
import DataUtils from '@/modules/core/services/data-utils';
import Scheduler from '@/modules/settings/data/scheduler';
import Utils from '@/modules/core/services/utils';

export default {
  name: "SchedulerTable",
  components: {
    SchedulerForm,
    DataTablePaginated
  },
  computed: {
    headers() {
      return [
        {text: this.$t('common:id'), value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('settings/settings:scheduler.buffer'), value: 'buffer'},
        {text: this.$t('settings/settings:scheduler.slots'), value: 'slots'},
        {text: this.$t('common:active'), value: 'active'},
        {text: "", value: "controls", sortable: false}
      ]
    },
    trueFalseDecorateFields() {
      return ['active'];
    }
  },
  methods: {
    updateTable(options, search) {
      if (!search) search = '';

      SchedulerService.readAllSchedulersPaginated(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          (response) => {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Scheduler);
            this.$refs.table.fillTableData(response.data);
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('settings/settings:scheduler.scheduler')}));
          }
      )
    },
    updateTableAfterManipulation() {
      this.$refs.table.callTableUpdate();
    },
    editScheduler(scheduler) {
      this.$refs.schedulerForm.initialization(scheduler);
    },
    deleteScheduler(scheduler) {
      SchedulerService.deleteScheduler(scheduler.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('settings/settings:scheduler.scheduler')}));
            this.updateTableAfterManipulation();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('settings/settings:scheduler.scheduler')}));
          }
      );
    }
  }
}
</script>